import { render, staticRenderFns } from "./FormBlockOverlay.vue?vue&type=template&id=507b5eba&scoped=true"
import script from "./FormBlockOverlay.vue?vue&type=script&lang=js"
export * from "./FormBlockOverlay.vue?vue&type=script&lang=js"
import style0 from "./FormBlockOverlay.vue?vue&type=style&index=0&id=507b5eba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507b5eba",
  null
  
)

export default component.exports